// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import UserEditScreen from "../../../src/screens/users/edit-screen"
import ScreenTitle from "../../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} UserEditRouteProps */

/** @typedef {Record<string, never>} UserEditRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<UserEditRouteProps, UserEditRouteState>}
 */
class UserEditRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("Edit user")}</ScreenTitle>
        <UserEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<UserEditRouteProps>} */
const UserEditRouteComponent = memo(shapeComponent(UserEditRoute))

export default UserEditRouteComponent
